import type { LucideIcon } from "lucide-react";
import {
  Sparkles, Smile, Star, HeartHandshake, Zap, Lightbulb, Search, TrendingUp, Leaf,
  Compass, Heart, Moon, Clock, Image, Waves, Sun, SmilePlus,
  Coffee, Wine, UtensilsCrossed, Footprints, CalendarDays, Activity, Shuffle,
} from "lucide-react";

// Catalogue figé des "moods" affichables sur un Real Vibe — miroir exact de la liste validée
// côté serveur (OLTODO-backend/src/utils/moodKeys.ts). 'invite_me' est toujours en première
// position (mise en avant visuelle dédiée), le reste est l'ordre d'affichage de la grille.
export const MOOD_KEYS = [
  "invite_me",
  "happy", "lucky", "grateful", "excited", "inspired", "curious", "motivated",
  "relaxed", "adventurous", "in_love", "tired", "bored", "nostalgic", "stressed",
  "proud", "serene", "optimistic", "surprised",
] as const;

export type MoodKey = typeof MOOD_KEYS[number];

export function isMoodKey(value: unknown): value is MoodKey {
  return typeof value === "string" && (MOOD_KEYS as readonly string[]).includes(value);
}

export const MOOD_WISH_KEYS = ["coffee", "drink", "restaurant", "go_out", "event", "activity", "anything"] as const;

export type MoodWishKey = typeof MOOD_WISH_KEYS[number];

export function isMoodWishKey(value: unknown): value is MoodWishKey {
  return typeof value === "string" && (MOOD_WISH_KEYS as readonly string[]).includes(value);
}

export const MOOD_ICONS: Record<MoodKey, LucideIcon> = {
  invite_me: Sparkles,
  happy: Smile,
  lucky: Star,
  grateful: HeartHandshake,
  excited: Zap,
  inspired: Lightbulb,
  curious: Search,
  motivated: TrendingUp,
  relaxed: Leaf,
  adventurous: Compass,
  in_love: Heart,
  tired: Moon,
  bored: Clock,
  nostalgic: Image,
  stressed: Waves,
  proud: Star,
  serene: Waves,
  optimistic: Sun,
  surprised: SmilePlus,
};

export const MOOD_WISH_ICONS: Record<MoodWishKey, LucideIcon> = {
  coffee: Coffee,
  drink: Wine,
  restaurant: UtensilsCrossed,
  go_out: Footprints,
  event: CalendarDays,
  activity: Activity,
  anything: Shuffle,
};

// Clé i18n du libellé d'un mood/d'une envie — évite de dupliquer le mapping "mood_xxx" partout
// où un mood doit être affiché (bouton MOOD, sheet, viewer).
export const moodLabelKey = (key: string) => `mood_${key}`;
export const wishLabelKey = (key: string) => `mood_wish_${key}`;
